import { type InferedInAppAdAttributesSchema } from "../../Shift/Open/types";
import { useShiftDiscoveryUserFiltersContext } from "../Filters/useUserFiltersContext";
import { ContextualEmptyState } from "./ListEmptyStateContextual";

interface ListViewPageOpenShiftsEmptyStateProps {
  readonly daysCount: number;
  readonly inAppAd?: InferedInAppAdAttributesSchema;
  readonly workerPaySurveyId?: string;
  readonly children?: React.ReactNode;
  readonly onClearFilters: () => void;
  readonly unfilteredShiftsLength: number;
}

const CONTEXTUAL_EMPTY_STATE_DATE_WINDOW = {
  shiftStartRelativeDaysGte: -7,
  shiftStartRelativeDaysLte: 21,
} as const;

export function ListViewPageOpenShiftsEmptyState(props: ListViewPageOpenShiftsEmptyStateProps) {
  const {
    daysCount,
    inAppAd,
    workerPaySurveyId,
    children,
    onClearFilters,
    unfilteredShiftsLength,
  } = props;
  const { appliedFiltersCount } = useShiftDiscoveryUserFiltersContext();

  return (
    <ContextualEmptyState
      appliedFiltersCount={appliedFiltersCount}
      daysCount={daysCount}
      inAppAd={inAppAd}
      unfilteredShiftsLength={unfilteredShiftsLength}
      workerPaySurveyId={workerPaySurveyId}
      shiftStartRelativeDaysGte={CONTEXTUAL_EMPTY_STATE_DATE_WINDOW.shiftStartRelativeDaysGte}
      shiftStartRelativeDaysLte={CONTEXTUAL_EMPTY_STATE_DATE_WINDOW.shiftStartRelativeDaysLte}
      onClearFilters={onClearFilters}
    >
      {children}
    </ContextualEmptyState>
  );
}
